  
export  const products = [
  { 
    id: 76, 
    name: '1 Gang 1 Way', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 10AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/1gangfront.jpg', '../Assets/SWE/1gangangle.jpg', '../Assets/SWE/1gangback.jpg'],
    tableimgUrl: ['../Assets/Table/SWEgangswitchtable.JPG']
  },
  { 
    id: 77, 
    name: '2 Gang 1 Way', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 10AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/2gangfront.jpg', '../Assets/SWE/2gangangle.jpg', '../Assets/SWE/2gangback.jpg'],
    tableimgUrl: ['../Assets/Table/SWEgangswitchtable.JPG'] 
  },
  // { 
  //   id: 78, 
  //   name: '3 Gang 1 Way', 
  //   description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 10AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
  //   imageUrls: ['../Assets/SWE/3gangfront.jpg', '../Assets/SWE/3gangangle.jpg', '../Assets/SWE/3gangback.jpg'],
  //   tableimgUrl: ['../Assets/Table/SWEgangswitchtable.jpg'] 
  // },
  { 
    id: 79, 
    name: '4 Gang 1 Way', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 10AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/4gang1front.jpg', '../Assets/SWE/4gang1angle.jpg', '../Assets/SWE/4gang1back.jpg'],
    tableimgUrl: ['../Assets/Table/SWEgangswitchtable.JPG'] 
  },
  { 
    id: 80, 
    name: '4 Gang 1 Way', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 10AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/4gang2front.jpg', '../Assets/SWE/4gang2angle.jpg', '../Assets/SWE/4gang2back.jpg'],
    tableimgUrl: ['../Assets/Table/SWEgangswitchtable.JPG'] 
  },
  { 
    id: 81, 
    name: '5 Gang 1 Way', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 10AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/5gangfront.jpg', '../Assets/SWE/5gangangle.jpg', '../Assets/SWE/5gangback.jpg'],
    tableimgUrl: ['../Assets/Table/SWEgangswitchtable.JPG'] 
  },
  { 
    id: 82, 
    name: '6 Gang 1 Way', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 10AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/6gangfront.jpg', '../Assets/SWE/6gangangle.jpg', '../Assets/SWE/6gangback.jpg'],
    tableimgUrl: ['../Assets/Table/SWEgangswitchtable.JPG'] 
  },
  { 
    id: 83, 
    name: '20 A DP Switch', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 20A <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/dp20front.jpg', '../Assets/SWE/dp20angle.jpg', '../Assets/SWE/dp20back.jpg'],
    tableimgUrl: ['../Assets/Table/SWE20DPtable.JPG'] 
  },
  { 
    id: 84, 
    name: '45 A DP Switch', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 45A <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/dp45front.jpg', '../Assets/SWE/dp45angle.jpg', '../Assets/SWE/dp45back.jpg'],
    tableimgUrl: ['../Assets/Table/SWE45DPtable.JPG'] 
  },
  { 
    id: 85, 
    name: '45 A DP Switch 3*6', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 45A <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/dp45longfront.jpg', '../Assets/SWE/dp45longangle.jpg', '../Assets/SWE/dp45longback.jpg'],
    tableimgUrl: ['../Assets/Table/SWE45DPtable.JPG'] 
  },
  { 
    id: 86, 
    name: 'Door Bell', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 10AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/doorbellfront.jpg', '../Assets/SWE/doorbellangle.jpg', '../Assets/SWE/doorbellback.jpg'],
    tableimgUrl: ['../Assets/Table/SWEgangswitchtable.JPG']
  },  
  { 
    id: 87, 
    name: '500W Fan Dimmer', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 10AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/fandimmer500front.jpg', '../Assets/SWE/fandimmer500angle.jpg', '../Assets/SWE/fandimmer500back.jpg'],
    tableimgUrl: ['../Assets/Table/SWEgangswitchtable.JPG']
  },
  { 
    id: 88, 
    name: '1000W Dimmer', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 10AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/fandimmer1000front.jpg', '../Assets/SWE/fandimmer1000angle.jpg', '../Assets/SWE/fandimmer1000back.jpg'],
    tableimgUrl: ['../Assets/Table/SWEgangswitchtable.JPG'] 
  },
  { 
    id: 89, 
    name: '2 Pin Socket', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 16AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/2pinsocketfront.jpg', '../Assets/SWE/2pinsocketangle.jpg', '../Assets/SWE/2pinsocketback.jpg'] ,
    tableimgUrl: ['../Assets/Table/2pinsockettable.JPG']
  },
  { 
    id: 90, 
    name: '5A Socket', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 5A <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/5socketfront.jpg', '../Assets/SWE/5socketangle.jpg', '../Assets/SWE/5socketback.jpg'] ,
    tableimgUrl: ['../Assets/Table/15A5Asocket.JPG']
  },
  { 
    id: 91, 
    name: '13A Socket Single', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 13AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/13socketfront.jpg', '../Assets/SWE/13socketangle.jpg', '../Assets/SWE/13socketback.jpg'] ,
    tableimgUrl: ['../Assets/Table/13Asockettable.JPG']
  },
  { 
    id: 92, 
    name: '13A Socket Double', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 13AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/13socketdoublefront.jpg', '../Assets/SWE/13socketdoubleangle.jpg', '../Assets/SWE/13socketdoubleback.jpg'],
    tableimgUrl: ['../Assets/Table/13Asockettable.JPG'] 
  },
  { 
    id: 93, 
    name: '13A Socket + 2 USB', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 13AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/13socketusbfront.jpg', '../Assets/SWE/13socketusbangle.jpg', '../Assets/SWE/13socketusbback.jpg'],
    tableimgUrl: ['../Assets/Table/13Asockettable.JPG'] 
  },
  { 
    id: 94, 
    name: '15A Socket', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 15AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/15socket1front.jpg', '../Assets/SWE/15socket1angle.jpg', '../Assets/SWE/15socket1back.jpg'],
    tableimgUrl: ['../Assets/Table/15A5Asocket.JPG'] 
  },
  { 
    id: 95, 
    name: '15A Socket Surface Type', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 15AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/15socket2front.jpg', '../Assets/SWE/15socket2angle.jpg', '../Assets/SWE/15socket2back.jpg'],
    tableimgUrl: ['../Assets/Table/15A5Asocket.JPG'] 
  },
  { 
    id: 96, 
    name: '16A Universal Socket', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 16AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/16socketfront.jpg', '../Assets/SWE/16socketangle.jpg', '../Assets/SWE/16socketback.jpg'],
    tableimgUrl: ['../Assets/Table/16Asockettable.JPG'] 
  },
  { 
    id: 97, 
    name: '16A Multi Socket + USB', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 16AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/16socketusbfront.jpg', '../Assets/SWE/16socketusbangle.jpg', '../Assets/SWE/16socketusbback.jpg'],
    tableimgUrl: ['../Assets/Table/16Asockettable.JPG'] 
  },
  { 
    id: 98, 
    name: 'Shaver Socket', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 10AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/shaversocketfront.jpg', '../Assets/SWE/shaversocketangle.jpg', '../Assets/SWE/shaversocketback.jpg'],
    tableimgUrl: ['../Assets/Table/SWEgangswitchtable.JPG'] 
  },
  
  { 
    id: 99, 
    name: 'TV Socket', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 10AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/tvsocketfront.jpg', '../Assets/SWE/tvsocketangle.jpg', '../Assets/SWE/tvsocketback.jpg'],
    tableimgUrl: ['../Assets/Table/SWEgangswitchtable.JPG'] 
  },  
  { 
    id: 100, 
    name: 'Telephone Socket', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 10AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/telephonesocketfront.jpg', '../Assets/SWE/telephonesocketangle.jpg', '../Assets/SWE/telephonesocketback.jpg'],
    tableimgUrl: ['../Assets/Table/SWEgangswitchtable.JPG'] 
  },
  { 
    id: 101, 
    name: 'Internet Socket', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 10AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/internetsocketfront.jpg', '../Assets/SWE/internetsocketangle.jpg', '../Assets/SWE/internetsocketback.jpg'],
    tableimgUrl: ['../Assets/Table/SWEgangswitchtable.JPG'] 
  },
  { 
    id: 102, 
    name: 'European Socket Single', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 16A <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/2pinearthingsocketsinglefront.jpg', '../Assets/SWE/2pinearthingsocketsingleangle.jpg', '../Assets/SWE/2pinearthingsocketsingleback.jpg'] ,
    tableimgUrl: ['../Assets/Table/16Asockettable.JPG']
  },
  { 
    id: 103, 
    name: 'European Socket double', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 16A <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/2pinearthingsocketdoublefront.jpg', '../Assets/SWE/2pinearthingsocketdoubleangle.jpg', '../Assets/SWE/2pinearthingsocketdoubleback.jpg'],
    tableimgUrl: ['../Assets/Table/16Asockettable.JPG'] 
  },
  { 
    id: 104, 
    name: 'European Socket Double Surface Type', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 16A <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/2pinearthingsocketdouble2front.jpg', '../Assets/SWE/2pinearthingsocketdouble2angle.jpg', '../Assets/SWE/2pinearthingsocketdouble2back.jpg'],
    tableimgUrl: ['../Assets/Table/16Asockettable.JPG'] 
  },
  { 
    id: 105, 
    name: '15A , 13A , 5A Plugs', 
    description: 'Standard: British Standard <br> Mechanical Life: 40,000 Times <br> Module Color: White <br> Max. Voltage: 250V <br> Current: 10AX <br> Type: Plate Switches <br> Certification: BSI, ASTA, ITS, CE, ISO9001, ISO14000 <br> Panel Materials: Bakelite <br> Inside Materials: Big Silver Contact, Brass Conductor', 
    imageUrls: ['../Assets/SWE/plugs.jpg', '../Assets/SWE/15plug.jpg', '../Assets/SWE/13plug.jpg'] ,
  },
  
  
];
    
    export default {
        products,
    }
  